<p-dialog [modal]="true" appendTo="body" [closable]="true" [minY]="70" [maximizable]="false"
  [style]="{width: '900px', minWidth: '900px'}" [(visible)]="isVisible" header="Cumulative Negotiation"
  (onHide)="handleSendFormManualReview()">

  <p-message severity="warn" [closable]="true">
    <div class="flex flex-row">
      <div>
        <b><i class="pi pi-exclamation-triangle warning-icon" style="font-size:20px;"></i></b>
      </div>
      <div class="ml-2">
        <span><b>Timeout Warning</b></span><br>
        <div style="margin-top:7px;">The request will be automatically sent for manual review in {{formattedTime}}</div>
      </div>
    </div>
  </p-message>
  <div>
    <b>Please Note: Closing the window will also send this request to manual review.</b>
    <br>
      <br>
        Per pre-established guidelines, you may request a total of {{adjudication?.cumulativeCap}} visits across all
        service disciplines for auto
        approval. You may adjust your visit request at this time by indicating {{adjudication?.cumulativeCap}} or less
        visits across the below service
        lines in the ‘New Requested’ box and select ‘Reprocess for Auto Approval’. Otherwise select ‘Send for Manual Review’
        to have a Carelon clinician review your request of your originally requested visits.
      </div>
      <form [formGroup]="negotiationCummulativeEditForm1">
        @if (adjudication.negotiations) {
          <div class="pt-4 p-datatable">
            <p-table #dt formArrayName="requestedAmount" [value]="adjudication.negotiations" dataKey="authorizationDetailId"
              [columns]="columns" [paginator]="false" [rows]="10" responsiveLayout="scroll">
              <ng-template pTemplate="colgroup" let-columns>
                <colgroup>
                @for (col of columns; track col) {
                  <col [style.width]="col.width">
                }
              </colgroup>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <tr>
                @for (col of columns; track col) {
                  <th [pSortableColumn]="col.field">
                    @switch (col.field) {
                      @default {
                        <span [innerText]='col.header'></span>
                      }
                    }
                  </th>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-neg let-rowIndex="rowIndex">
              <tr [formGroupName]="rowIndex">
                <td >{{neg.skillCode}}</td>
                <td >{{neg.effectiveFromDate | date: 'MM/dd/yyyy'}}</td>
                <td >{{neg.effectiveToDate | date: 'MM/dd/yyyy'}}</td>
                <td >{{neg.requestedAmount}}</td>
                <td  pEditableColumn>
                  <div>
                    <input class="p-column-input p-input-width" pInputText type="number" formControlName="newAmount"
                      name="newRequestedAmount">
                      <span
                        tooltipPosition="bottom"
                        class="ml-2"
                        pTooltip="Value between 1-99"
                        tooltipStyleClass="tooltip-xl-size"
                        >
                        <i class="pi pi-info-circle" style="font-size:0.9rem;" ></i>
                      </span>
                    </div>
                  </td>
                  @if (neg.skillCapAmount && (requestedAmount.controls[rowIndex].value.newAmount > neg.skillCapAmount)) {
                    <td class="error font-semibold"
                      >
                      {{neg.skillCapAmount}}
                    </td>
                  }
                  @if (!neg.skillCapAmount || (requestedAmount.controls[rowIndex].value.newAmount <= neg.skillCapAmount)) {
                    <td
                      >
                      {{neg.skillCapAmount}}
                    </td>
                  }
                </tr>
              </ng-template>
            </p-table>
          </div>
        }
      </form>
      <ng-template #footer>
        <button pButton type="button" class="p-button-secondary" label="Close"
        (click)="handleSendFormManualReview()"></button>
        <button pButton type="button" class="p-button-raised" icon="" (click)="handleSendFormManualReview()"
          label="Send for Manual Review">
        </button>
        <button pButton class="p-button-raised" icon="" (click)="handleReprocessForAutoApproval()"
          [disabled]="!negotiationCummulativeEditForm1.valid || totalAllowedVisitsExceeded"
          label="Reprocess for Auto Approval">
        </button>
      </ng-template>
    </p-dialog>
